/* eslint no-useless-escape: 0 */

module.exports = {
  eMandateSvcEnabled: true,
  addressFormat: 'addressLine1,postalCode,city',
  products: [
    {
      id: '1',
      refId: '1',
      name: 'Online',
      isShippingAddressRequired: false,
      st: 'DIGITAL',
    },
    {
      id: '2',
      refId: '2',
      name: 'Meetings',
      isShippingAddressRequired: true,
      st: 'WORKSHOP,STUDIO',
    },
    {
      id: '8',
      refId: '1',
      name: 'eTools',
      isShippingAddressRequired: false,
    },
    {
      id: '14',
      refId: '1',
      name: 'Online iTunes',
      isShippingAddressRequired: false,
    },
    {
      id: '22',
      refId: '0',
      name: 'Virtual Group Coaching + Digital',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
    {
      id: '23',
      refId: '0',
      name: 'Virtual Community',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
      st: 'VIRTUAL_COMMUNITY',
    },
    {
      id: '24',
      refId: '0',
      name: 'Virtual Community + Workshop',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
      st: 'WORKSHOP_VIRTUAL_COMMUNITY',
    },
    {
      id: '25',
      refId: '0',
      name: 'Digital360 iTunes',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
    {
      id: '27',
      refId: '0',
      name: 'Digital360 Android',
      addressVerificationRequired: false,
      isShippingAddressRequired: false,
    },
  ],
  validations: {
    firstName: {},
    lastName: {},
    addressLine1: {
      regex:
        "^[A-Za-zÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÖẞößàâäèéêëîïôœùûüÿÇç€0-9\\. /\\-',#]*[A-Za-zÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÖẞößàâäèéêëîïôœùûüÿÇç€]+[A-Za-zÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÖẞößàâäèéêëîïôœùûüÿÇç€0-9\\. /\\-',#]*$",
    },
    addressLine2: {
      regex:
        "^$|^[A-Za-zÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÖẞößàâäèéêëîïôœùûüÿÇç€0-9\\. /\\-',#]*[A-Za-zÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÖẞößàâäèéêëîïôœùûüÿÇç€]+[A-Za-zÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÖẞößàâäèéêëîïôœùûüÿÇç€0-9\\. /\\-',#]*$",
    },
    city: {
      regex: '^[a-zA-ZÄäÖößÜüé. -]*[a-zA-ZÄäÖößÜüé]+[a-zA-ZÄäÖößÜüé. -]*$',
    },
    postalCode: {
      type: 'string',
      min: 5,
      max: 5,
      regex: '^\\d{5}$',
      regexFlags: '',
      numbersOnly: true,
    },
    state: {
      required: true,
    },
    ccNumber: {
      min: 8,
      max: 20,
    },
    ccCVVNo: {},
    ibanNumber: {
      required: true,
      max: 34,
    },
    bicNumber: {
      required: true,
      max: 11,
      regex: '^[A-Za-z]{4}[A-Za-z]{2}([A-Za-z0-9]{2}|[A-Za-z0-9]{5})$',
    },
  },
  payment: {
    modes: ['FLEX', 'DD', 'CC', 'PP'],
    SEPAId: 12,
    supportedCCs: [
      { id: 1, tid: 21, name: 'VISA', ccName: 'VISA' },
      { id: 2, tid: 22, name: 'MASTERCARD', ccName: 'MASTER CARD' },
      { id: 3, tid: 23, name: 'AMERICAN EXPRESS', ccName: 'AMERICAN EXPRESS' },
    ],
  },
};
